import React from 'react';
import { ClipboardList, FileOutput, FileText, Shield } from 'lucide-react';

const SECCIONES = [
  ['ros', 'ROS', Shield], ['solicitudes', 'Solicitudes', ClipboardList],
  ['informes', 'Informes', FileOutput], ['documentos', 'Documentos', FileText],
];

// F6: Gestión = ROS, Solicitudes, Informes y Documentos como sub-secciones.
export const CasoGestionTab = ({ sub, onSub, contadores = {}, secciones }) => (
  <div data-testid="caso-gestion-tab">
    <div className="mb-5 inline-flex flex-wrap rounded-lg border border-slate-200 bg-slate-50 p-0.5">
      {SECCIONES.map(([k, l, Icono]) => (
        <button key={k} type="button" onClick={() => onSub(k)} data-testid={`gestion-sub-${k}`}
          className={`flex items-center gap-1.5 rounded-md px-3.5 py-1.5 text-sm transition-colors ${sub === k ? 'bg-white font-semibold text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-800'}`}>
          <Icono size={14} /> {l}
          {contadores[k] > 0 && <span className="rounded-full bg-slate-200 px-1.5 text-[10px] font-bold text-slate-700">{contadores[k]}</span>}
        </button>
      ))}
    </div>
    {secciones[sub]}
  </div>
);

export default CasoGestionTab;
